import { Grid, GridItem } from "@chakra-ui/react";
import { DataCard } from "./DatCard";

export const DataGrid = ({ tabKey, data, formState, onInputChange }) => {
  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={2}>
      {Object.entries(data).map(([key, value]) => {
        if (
          !value ||
          typeof value !== "object" ||
          !("MESSAGE" in value) ||
          !("VALUE" in value) ||
          value?.VISIBLE === false
        ) {
          return null;
        }

        const editable = value?.EDITABLE;
        const val = editable ? formState?.[key] ?? value.VALUE : value.VALUE;
        const isTextBox = value.TYPE === "TextBox";

        return (
          <GridItem key={key} colSpan={isTextBox ? 4 : 1}>
            <DataCard
              label={value.MESSAGE}
              code={value.REFERENCE?.CODE}
              referenceMap={value.REFERENCE}
              value={val}
              tooltip={value.TOOLTIP}
              isEditable={editable}
              enumOptions={value.TYPE === "Dropdown" ? value.ENUM : undefined}
              onChange={(newVal) => onInputChange(key, newVal)}
              type={value.TYPE}
              multiSelectType={value.MULTISELECT_TYPE}
            />
          </GridItem>
        );
      })}
    </Grid>
  );
};
